'use client';

import { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface WebinarCardProps {
  title: string;
  description: string;
  speaker: string;
  speakerTitle: string;
  date: string;
  duration: string;
  image: string;
  alt: string;
  registrationUrl: string;
  attendees: number;
}

export default function WebinarCard({
  title,
  description,
  speaker,
  speakerTitle,
  date,
  duration,
  image,
  alt,
  registrationUrl,
  attendees,
}: WebinarCardProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useState(() => {
    setIsHydrated(true);
  });

  const handleRegister = () => {
    if (!isHydrated) return;
    console.log(`Registering for: ${registrationUrl}`);
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-brand transition-all duration-300">
      <div className="relative h-56 overflow-hidden">
        <AppImage
          src={image}
          alt={alt}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-3 right-3">
          <span className="px-3 py-1 bg-brand-accent text-white text-xs font-semibold rounded-full">
            Upcoming
          </span>
        </div>
      </div>
      
      <div className="p-6">
        <h3 className="text-xl font-semibold text-text-primary mb-3">
          {title}
        </h3>
        <p className="text-sm text-text-secondary mb-4 line-clamp-2">
          {description}
        </p>
        
        <div className="space-y-3 mb-5">
          <div className="flex items-center space-x-2 text-sm text-text-secondary">
            <Icon name="UserIcon" size={18} />
            <span className="font-medium text-text-primary">{speaker}</span>
            <span>•</span>
            <span>{speakerTitle}</span>
          </div>
          
          <div className="flex items-center space-x-4 text-sm text-text-secondary">
            <span className="flex items-center space-x-2">
              <Icon name="CalendarIcon" size={18} />
              <span>{date}</span>
            </span>
            <span className="flex items-center space-x-2">
              <Icon name="ClockIcon" size={18} />
              <span>{duration}</span>
            </span>
          </div>
          
          <div className="flex items-center space-x-2 text-sm text-text-secondary">
            <Icon name="UsersIcon" size={18} />
            <span>{attendees} registered</span>
          </div>
        </div>
        
        <button
          onClick={handleRegister}
          disabled={!isHydrated}
          className="w-full px-5 py-3 bg-brand-cta text-white font-semibold rounded-md hover:bg-red-700 transition-colors disabled:opacity-50"
        >
          Register Now
        </button>
      </div>
    </div>
  );
}